export default __webpack_public_path__ + "static/media/A003sarim.8bd8647e.jpg";